import { ZonesTable } from './ZonesTable';

export default ZonesTable;
